import React from "react";
import { FormattedMessage } from "react-intl";
import {
     TextField,
     Divider,
     InputAdornment,
     CircularProgress,
     Button,
   } from "@material-ui/core";
import DialogModalHeader from "../../../../../components/dialogModal/dialogModalHeader";
import FilterListIcon from "@material-ui/icons/FilterList";
import ErrorMessage from "../switchAccountError/switchAccountError";
import "./_switchAccountPopup.scss";
   
   export const SwitchAccountSuccess = (props) => {
     let default_account = props.account_list.find(account => account.is_default);
     return (
       <>
         <div>
           <FormattedMessage
             defaultMessage="For the switch to {account_name} to take effect, manually sign out and back in to all of your Trimble products and services."
             values={{
               account_name: <span style={{ fontWeight: 600 }}>{default_account?.name}</span>
             }}
           />
         </div>
         
         <Button
           className="action-button"
           onClick={(e) => props.handleSetDefault(e)}
           color="primary"
           disableElevation
           variant="contained"
           disabled ={props.accSwitch === "pending"}
         >
         <FormattedMessage defaultMessage="Switch" />
         </Button>
         <br/>
         <Button
           className="disable-button"
           onClick={(e) => props.handleClose(e)}
           color="primary"
           disableElevation
           variant="outlined"
           disabled ={props.accSwitch === "pending"}
         >
         <FormattedMessage defaultMessage="Cancel" />
         </Button>
       </>
     );
   };
   export const DisplayAccount = (props) => {
     var account_list = props.account_list && props.account_list.sort((a, b) => b.is_default - a.is_default);
     return (
       <div className="account-list">
         {account_list &&
           account_list.map((account, i) => (
             <div key={i}>
               <div className="account-disp">
                 <div className="acc-name">{account.name}</div>
                 {account.is_default ? (
                   <div className="custom-badge-grey"><FormattedMessage defaultMessage="Default"/></div>
                 ) : (
                   <div>
                     <a
                       href=""
                       onClick={(e) => props.handleSwitch(e, account.name)}
                     >
                       <FormattedMessage defaultMessage="Set default" />
                     </a>
                   </div>
                 )}
               </div>
               <Divider />
             </div>
           ))}
       </div>
     );
   };
const SwitchAccountPopup = (props) => {
     return (
      
        <div className="account-modal-body">
         <DialogModalHeader
         title = {props.accSwitch !== "" ? <FormattedMessage defaultMessage="Confirm account switch"/> : <FormattedMessage defaultMessage="Switch account"/>}
         hide_cancel = {props.accSwitch === "selected"} 
         />
       
         {props.error && 
         <ErrorMessage 
         error = {props.error}/>}

         {props.accSwitch !== "" ? (
             <SwitchAccountSuccess
               accSwitch = {props.accSwitch}
               handleSetDefault={props.handleSetDefault}
               account_list={props.filteredAccList}
               handleClose={props.handleClose}
             />
         ) : (
           <>
             {props.acc_list && props.acc_list.length >= 0 ? (
               <div>
                 <div><FormattedMessage defaultMessage="You have {account_length} accounts." values={{
                                                    account_length: props.acc_list.length
                                               }}/>
                </div>

                 <br />
                 {props.acc_list.length > 5 &&
                 <TextField
                   placeholder="Filter by account name"
                   className="search-text-field"
                   value={props.inputValue}
                   onChange={(e) => props.handleInputChange(e)}
                   variant="outlined"
                   InputProps={{
                     startAdornment: (
                       <InputAdornment position="start">
                         <FilterListIcon />
                       </InputAdornment>
                     ),
                   }}
                 />}
   
                 <DisplayAccount
                   account_list={props.filteredAccList}
                   handleSwitch={props.handleSwitch}
                 />
               </div>
             ) : (
               <div className="progress-spin">
                 <CircularProgress size="2rem" />
               </div>
             )}
           </>
         )}
     </div>
      
     );
   };

   export default SwitchAccountPopup;